const DataValueTypes = {
  ORDER_NOS: 'order_nos',
  FREIGHT_PROVISION: 'FREIGHT_PROVISION',
  INVOICE: 'INVOICE',
  INVOICE_DEPOT_STATUS: 'invoice_depot_status',
  INVOICE_STATUS: 'invoice_status',
  FREIGHT_BILL_DEPOT_COUNT: 'freight_bill_depot_count',
  INVOICE_DEPOT_COUNT: 'invoice_depot_count',
};

const DataValueRelations = {
  FREIGHT_BILL: 'freight_bill',
  FREIGHT_PROVISION_ERP_UPDATE: 'FREIGHT_PROVISION_ERP_UPDATE',
  E_INVOICE_ERP_UPDATE: 'E_INVOICE_ERP_UPDATE',
  INVOICE: 'invoice',
};

const ErpUpdateStatus = {
  FREIGHT_PROVISION_POST_FAILED: 'FREIGHT_PROVISION_POST_FAILED',
  FREIGHT_PROVISION_POST_SUCCESS: 'FREIGHT_PROVISION_POST_SUCCESS',
  FREIGHT_PROVISION_POST_SUCCESS_TIMEOUT: 'FREIGHT_PROVISION_POST_SUCCESS_TIMEOUT',
  FREIGHT_PROVISION_POST_INITIATED: 'FREIGHT_PROVISION_POST_INITIATED',
  INVOICE_POST_SUCCESS: 'INVOICE_POST_SUCCESS',
  INVOICE_POST_FAILED: 'INVOICE_POST_FAILED',
};

module.exports = {
  DataValueRelations,
  DataValueTypes,
  ErpUpdateStatus,
};
